module.exports = __webpack_public_path__ + "img/nor_tt_moun2.f16c4109.png";